/** Curated undergraduate institutions (US-heavy + popular UK/AU/NZ/CA). Domain is for favicon lookup only; rows still appear if the icon fails. */
export type RawInstitution = { name: string; domain: string };

export const RAW_UNDERGRADUATE_INSTITUTIONS: RawInstitution[] = [
  { name: 'Adelphi University', domain: 'adelphi.edu' },
  { name: 'Alabama A&M University', domain: 'aamu.edu' },
  { name: 'Alfred University', domain: 'alfred.edu' },
  { name: 'American University', domain: 'american.edu' },
  { name: 'Appalachian State University', domain: 'appstate.edu' },
  { name: 'Arizona State University', domain: 'asu.edu' },
  { name: 'Arkansas State University', domain: 'astate.edu' },
  { name: 'Arkansas Tech University', domain: 'atu.edu' },
  { name: 'Assumption University', domain: 'assumption.edu' },
  { name: 'Auburn University', domain: 'auburn.edu' },
  { name: 'Australian National University', domain: 'anu.edu.au' },
  { name: 'Azusa Pacific University', domain: 'apu.edu' },
  { name: 'Ball State University', domain: 'bsu.edu' },
  { name: 'Barnard College', domain: 'barnard.edu' },
  { name: 'Bates College', domain: 'bates.edu' },
  { name: 'Baylor University', domain: 'baylor.edu' },
  { name: 'Belmont University', domain: 'belmont.edu' },
  { name: 'Beloit College', domain: 'beloit.edu' },
  { name: 'Bellarmine University', domain: 'bellarmine.edu' },
  { name: 'Bennington College', domain: 'bennington.edu' },
  { name: 'Biola University', domain: 'biola.edu' },
  { name: 'Binghamton University, SUNY', domain: 'binghamton.edu' },
  { name: 'Birkbeck, University of London', domain: 'bbk.ac.uk' },
  { name: 'Boise State University', domain: 'boisestate.edu' },
  { name: 'Boston College', domain: 'bc.edu' },
  { name: 'Boston University', domain: 'bu.edu' },
  { name: 'Bowdoin College', domain: 'bowdoin.edu' },
  { name: 'Bowling Green State University', domain: 'bgsu.edu' },
  { name: 'Bradley University', domain: 'bradley.edu' },
  { name: 'Brandeis University', domain: 'brandeis.edu' },
  { name: 'Brigham Young University', domain: 'byu.edu' },
  { name: 'Brigham Young University–Idaho', domain: 'byui.edu' },
  { name: 'Brown University', domain: 'brown.edu' },
  { name: 'Brunel University London', domain: 'brunel.ac.uk' },
  { name: 'Bucknell University', domain: 'bucknell.edu' },
  { name: 'Butler University', domain: 'butler.edu' },
  { name: 'California Institute of Technology', domain: 'caltech.edu' },
  { name: 'California Lutheran University', domain: 'callutheran.edu' },
  { name: 'California Polytechnic State University, San Luis Obispo', domain: 'calpoly.edu' },
  { name: 'California State Polytechnic University, Pomona', domain: 'cpp.edu' },
  { name: 'California State University, Chico', domain: 'csuchico.edu' },
  { name: 'California State University, Fresno', domain: 'fresnostate.edu' },
  { name: 'California State University, Fullerton', domain: 'fullerton.edu' },
  { name: 'California State University, Long Beach', domain: 'csulb.edu' },
  { name: 'California State University, Los Angeles', domain: 'calstatela.edu' },
  { name: 'California State University, Northridge', domain: 'csun.edu' },
  { name: 'California State University, Sacramento', domain: 'csus.edu' },
  { name: 'California State University, San Bernardino', domain: 'csusb.edu' },
  { name: 'Calvin University', domain: 'calvin.edu' },
  { name: 'Cardiff University', domain: 'cardiff.ac.uk' },
  { name: 'Carleton College', domain: 'carleton.edu' },
  { name: 'Carleton University', domain: 'carleton.ca' },
  { name: 'Carnegie Mellon University', domain: 'cmu.edu' },
  { name: 'Carroll University', domain: 'carrollu.edu' },
  { name: 'Case Western Reserve University', domain: 'case.edu' },
  { name: 'Centre College', domain: 'centre.edu' },
  { name: 'Champlain College', domain: 'champlain.edu' },
  { name: 'Chapman University', domain: 'chapman.edu' },
  { name: 'Christopher Newport University', domain: 'cnu.edu' },
  { name: 'City, University of London', domain: 'city.ac.uk' },
  { name: 'Claremont McKenna College', domain: 'cmc.edu' },
  { name: 'Clemson University', domain: 'clemson.edu' },
  { name: 'Coastal Carolina University', domain: 'coastal.edu' },
  { name: 'Coe College', domain: 'coe.edu' },
  { name: 'Colby College', domain: 'colby.edu' },
  { name: 'Colgate University', domain: 'colgate.edu' },
  { name: 'College of Charleston', domain: 'cofc.edu' },
  { name: 'College of Idaho', domain: 'collegeofidaho.edu' },
  { name: 'Colorado School of Mines', domain: 'mines.edu' },
  { name: 'Colorado State University', domain: 'colostate.edu' },
  { name: 'Columbia University', domain: 'columbia.edu' },
  { name: 'Concordia University', domain: 'concordia.ca' },
  { name: 'Connecticut College', domain: 'conncoll.edu' },
  { name: 'Cooper Union for the Advancement of Science and Art', domain: 'cooper.edu' },
  { name: 'Cornell College', domain: 'cornellcollege.edu' },
  { name: 'Cornell University', domain: 'cornell.edu' },
  { name: 'Creighton University', domain: 'creighton.edu' },
  { name: 'Curtin University', domain: 'curtin.edu.au' },
  { name: 'Dalhousie University', domain: 'dal.ca' },
  { name: 'Dartmouth College', domain: 'dartmouth.edu' },
  { name: 'Davidson College', domain: 'davidson.edu' },
  { name: 'Deakin University', domain: 'deakin.edu.au' },
  { name: 'DePaul University', domain: 'depaul.edu' },
  { name: 'DePauw University', domain: 'depauw.edu' },
  { name: 'Drexel University', domain: 'drexel.edu' },
  { name: 'Drake University', domain: 'drake.edu' },
  { name: 'Duke University', domain: 'duke.edu' },
  { name: 'Durham University', domain: 'durham.ac.uk' },
  { name: 'East Carolina University', domain: 'ecu.edu' },
  { name: 'East Tennessee State University', domain: 'etsu.edu' },
  { name: 'Eastern Kentucky University', domain: 'eku.edu' },
  { name: 'Eastern Michigan University', domain: 'emich.edu' },
  { name: 'Eastern Washington University', domain: 'ewu.edu' },
  { name: 'Edith Cowan University', domain: 'ecu.edu.au' },
  { name: 'Elon University', domain: 'elon.edu' },
  { name: 'Embry–Riddle Aeronautical University', domain: 'erau.edu' },
  { name: 'Emory University', domain: 'emory.edu' },
  { name: 'Fairfield University', domain: 'fairfield.edu' },
  { name: 'Fashion Institute of Technology', domain: 'fitnyc.edu' },
  { name: 'Ferris State University', domain: 'ferris.edu' },
  { name: 'Florida Agricultural and Mechanical University', domain: 'famu.edu' },
  { name: 'Florida Atlantic University', domain: 'fau.edu' },
  { name: 'Florida International University', domain: 'fiu.edu' },
  { name: 'Florida State University', domain: 'fsu.edu' },
  { name: 'Fordham University', domain: 'fordham.edu' },
  { name: 'Fort Lewis College', domain: 'fortlewis.edu' },
  { name: 'Frostburg State University', domain: 'frostburg.edu' },
  { name: 'Furman University', domain: 'furman.edu' },
  { name: 'George Mason University', domain: 'gmu.edu' },
  { name: 'George Washington University', domain: 'gwu.edu' },
  { name: 'Georgetown University', domain: 'georgetown.edu' },
  { name: 'Georgia College & State University', domain: 'gcsu.edu' },
  { name: 'Georgia Institute of Technology', domain: 'gatech.edu' },
  { name: 'Georgia Southern University', domain: 'georgiasouthern.edu' },
  { name: 'Georgia State University', domain: 'gsu.edu' },
  { name: 'Gonzaga University', domain: 'gonzaga.edu' },
  { name: 'Goucher College', domain: 'goucher.edu' },
  { name: 'Grand Valley State University', domain: 'gvsu.edu' },
  { name: 'Griffith University', domain: 'griffith.edu.au' },
  { name: 'Grinnell College', domain: 'grinnell.edu' },
  { name: 'Hamilton College', domain: 'hamilton.edu' },
  { name: 'Hampton University', domain: 'hamptonu.edu' },
  { name: 'Harvard University', domain: 'harvard.edu' },
  { name: 'Harvey Mudd College', domain: 'hmc.edu' },
  { name: 'Haverford College', domain: 'haverford.edu' },
  { name: 'Hendrix College', domain: 'hendrix.edu' },
  { name: 'Heriot-Watt University', domain: 'hw.ac.uk' },
  { name: 'High Point University', domain: 'highpoint.edu' },
  { name: 'Hofstra University', domain: 'hofstra.edu' },
  { name: 'Hong Kong University of Science and Technology', domain: 'ust.hk' },
  { name: 'Hope College', domain: 'hope.edu' },
  { name: 'Howard University', domain: 'howard.edu' },
  { name: 'Illinois Institute of Technology', domain: 'iit.edu' },
  { name: 'Illinois State University', domain: 'illinoisstate.edu' },
  { name: 'Illinois Wesleyan University', domain: 'iwu.edu' },
  { name: 'Imperial College London', domain: 'imperial.ac.uk' },
  { name: 'Indiana University Bloomington', domain: 'iu.edu' },
  { name: 'Indiana University–Purdue University Indianapolis', domain: 'iupui.edu' },
  { name: 'Iowa State University', domain: 'iastate.edu' },
  { name: 'Ithaca College', domain: 'ithaca.edu' },
  { name: 'James Cook University', domain: 'jcu.edu.au' },
  { name: 'James Madison University', domain: 'jmu.edu' },
  { name: 'Johns Hopkins University', domain: 'jhu.edu' },
  { name: 'Kalamazoo College', domain: 'kzoo.edu' },
  { name: 'Kansas State University', domain: 'ksu.edu' },
  { name: 'Kennesaw State University', domain: 'kennesaw.edu' },
  { name: "King's College London", domain: 'kcl.ac.uk' },
  { name: 'Kent State University', domain: 'kent.edu' },
  { name: 'Kenyon College', domain: 'kenyon.edu' },
  { name: 'La Trobe University', domain: 'latrobe.edu.au' },
  { name: 'Lafayette College', domain: 'lafayette.edu' },
  { name: 'Lamar University', domain: 'lamar.edu' },
  { name: 'Lancaster University', domain: 'lancaster.ac.uk' },
  { name: 'Lawrence University', domain: 'lawrence.edu' },
  { name: 'Lehigh University', domain: 'lehigh.edu' },
  { name: 'Liberty University', domain: 'liberty.edu' },
  { name: 'London School of Economics and Political Science', domain: 'lse.ac.uk' },
  { name: 'Longwood University', domain: 'longwood.edu' },
  { name: 'Louisiana State University', domain: 'lsu.edu' },
  { name: 'Louisiana Tech University', domain: 'latech.edu' },
  { name: 'Loyola Marymount University', domain: 'lmu.edu' },
  { name: 'Loyola University Chicago', domain: 'luc.edu' },
  { name: 'Loyola University Maryland', domain: 'loyola.edu' },
  { name: 'Loyola University New Orleans', domain: 'loyno.edu' },
  { name: 'Macalester College', domain: 'macalester.edu' },
  { name: 'Macquarie University', domain: 'mq.edu.au' },
  { name: 'Manhattan College', domain: 'manhattan.edu' },
  { name: 'Marquette University', domain: 'marquette.edu' },
  { name: 'Marshall University', domain: 'marshall.edu' },
  { name: 'Mary Baldwin University', domain: 'marybaldwin.edu' },
  { name: 'Mary Washington University', domain: 'umw.edu' },
  { name: 'Massachusetts Institute of Technology', domain: 'mit.edu' },
  { name: 'McDaniel College', domain: 'mcdaniel.edu' },
  { name: 'McGill University', domain: 'mcgill.ca' },
  { name: 'McMaster University', domain: 'mcmaster.ca' },
  { name: 'McNeese State University', domain: 'mcneese.edu' },
  { name: 'Mercer University', domain: 'mercer.edu' },
  { name: 'Miami University', domain: 'miamioh.edu' },
  { name: 'Michigan State University', domain: 'msu.edu' },
  { name: 'Michigan Technological University', domain: 'mtu.edu' },
  { name: 'Middle Tennessee State University', domain: 'mtsu.edu' },
  { name: 'Middlebury College', domain: 'middlebury.edu' },
  { name: 'Millsaps College', domain: 'millsaps.edu' },
  { name: 'Mississippi College', domain: 'mc.edu' },
  { name: 'Mississippi State University', domain: 'msstate.edu' },
  { name: 'Missouri State University', domain: 'missouristate.edu' },
  { name: 'Monash University', domain: 'monash.edu.au' },
  { name: 'Montana State University', domain: 'montana.edu' },
  { name: 'Montana Technological University', domain: 'mtech.edu' },
  { name: 'Morehouse College', domain: 'morehouse.edu' },
  { name: 'Mount Holyoke College', domain: 'mtholyoke.edu' },
  { name: 'Murray State University', domain: 'murraystate.edu' },
  { name: 'National University of Singapore', domain: 'nus.edu.sg' },
  { name: 'New College of Florida', domain: 'ncf.edu' },
  { name: 'New Jersey Institute of Technology', domain: 'njit.edu' },
  { name: 'New Mexico State University', domain: 'nmsu.edu' },
  { name: 'New Mexico Institute of Mining and Technology', domain: 'nmt.edu' },
  { name: 'New York University', domain: 'nyu.edu' },
  { name: 'Newcastle University', domain: 'ncl.ac.uk' },
  { name: 'Nicholls State University', domain: 'nicholls.edu' },
  { name: 'North Carolina A&T State University', domain: 'ncat.edu' },
  { name: 'North Carolina State University', domain: 'ncsu.edu' },
  { name: 'North Dakota State University', domain: 'ndsu.edu' },
  { name: 'Northeastern University', domain: 'northeastern.edu' },
  { name: 'Northern Arizona University', domain: 'nau.edu' },
  { name: 'Northern Illinois University', domain: 'niu.edu' },
  { name: 'Northwestern University', domain: 'northwestern.edu' },
  { name: 'Norwich University', domain: 'norwich.edu' },
  { name: 'Oakland University', domain: 'oakland.edu' },
  { name: 'Occidental College', domain: 'oxy.edu' },
  { name: 'The Ohio State University', domain: 'osu.edu' },
  { name: 'Ohio University', domain: 'ohio.edu' },
  { name: 'Oklahoma State University', domain: 'okstate.edu' },
  { name: 'Old Dominion University', domain: 'odu.edu' },
  { name: 'Pace University', domain: 'pace.edu' },
  { name: 'Pennsylvania State University', domain: 'psu.edu' },
  { name: 'Pepperdine University', domain: 'pepperdine.edu' },
  { name: 'Pitzer College', domain: 'pitzer.edu' },
  { name: 'Pomona College', domain: 'pomona.edu' },
  { name: 'Portland State University', domain: 'pdx.edu' },
  { name: 'Princeton University', domain: 'princeton.edu' },
  { name: 'Purdue University', domain: 'purdue.edu' },
  { name: 'Purdue University Fort Wayne', domain: 'pfw.edu' },
  { name: 'Purdue University Northwest', domain: 'pnw.edu' },
  { name: 'Queen Mary University of London', domain: 'qmul.ac.uk' },
  { name: "Queen's University Belfast", domain: 'qub.ac.uk' },
  { name: "Queen's University at Kingston", domain: 'queensu.ca' },
  { name: 'Quinnipiac University', domain: 'qu.edu' },
  { name: 'Radford University', domain: 'radford.edu' },
  { name: 'Ramapo College of New Jersey', domain: 'ramapo.edu' },
  { name: 'Rensselaer Polytechnic Institute', domain: 'rpi.edu' },
  { name: 'Rhodes College', domain: 'rhodes.edu' },
  { name: 'Rice University', domain: 'rice.edu' },
  { name: 'Rider University', domain: 'rider.edu' },
  { name: 'Rochester Institute of Technology', domain: 'rit.edu' },
  { name: 'RMIT University', domain: 'rmit.edu.au' },
  { name: 'Rollins College', domain: 'rollins.edu' },
  { name: 'Rose–Hulman Institute of Technology', domain: 'rose-hulman.edu' },
  { name: 'Rowan University', domain: 'rowan.edu' },
  { name: 'Royal Holloway, University of London', domain: 'rhul.ac.uk' },
  { name: 'Rutgers University', domain: 'rutgers.edu' },
  { name: 'Sacred Heart University', domain: 'sacredheart.edu' },
  { name: 'Saint Louis University', domain: 'slu.edu' },
  { name: 'Salisbury University', domain: 'salisbury.edu' },
  { name: 'Sam Houston State University', domain: 'shsu.edu' },
  { name: 'San Diego State University', domain: 'sdsu.edu' },
  { name: 'San Francisco State University', domain: 'sfsu.edu' },
  { name: 'San José State University', domain: 'sjsu.edu' },
  { name: 'Santa Clara University', domain: 'scu.edu' },
  { name: 'Savannah State University', domain: 'savannahstate.edu' },
  { name: 'School of the Art Institute of Chicago', domain: 'saic.edu' },
  { name: 'Scripps College', domain: 'scrippscollege.edu' },
  { name: 'Seattle Pacific University', domain: 'spu.edu' },
  { name: 'Seattle University', domain: 'seattleu.edu' },
  { name: 'Seton Hall University', domain: 'shu.edu' },
  { name: 'Shepherd University', domain: 'shepherd.edu' },
  { name: 'Simon Fraser University', domain: 'sfu.ca' },
  { name: 'Skidmore College', domain: 'skidmore.edu' },
  { name: 'Smith College', domain: 'smith.edu' },
  { name: 'SOAS University of London', domain: 'soas.ac.uk' },
  { name: 'South Dakota State University', domain: 'sdstate.edu' },
  { name: 'Southern Connecticut State University', domain: 'southernct.edu' },
  { name: 'Southern Illinois University Carbondale', domain: 'siu.edu' },
  { name: 'Southern Illinois University Edwardsville', domain: 'siue.edu' },
  { name: 'Southern Methodist University', domain: 'smu.edu' },
  { name: 'Southern Utah University', domain: 'suu.edu' },
  { name: 'Spelman College', domain: 'spelman.edu' },
  { name: 'Stanford University', domain: 'stanford.edu' },
  { name: 'Stephen F. Austin State University', domain: 'sfasu.edu' },
  { name: 'Stevens Institute of Technology', domain: 'stevens.edu' },
  { name: 'Stockton University', domain: 'stockton.edu' },
  { name: 'Stony Brook University, SUNY', domain: 'stonybrook.edu' },
  { name: 'Suffolk University', domain: 'suffolk.edu' },
  { name: 'Swarthmore College', domain: 'swarthmore.edu' },
  { name: 'Swinburne University of Technology', domain: 'swinburne.edu.au' },
  { name: 'Syracuse University', domain: 'syracuse.edu' },
  { name: 'Temple University', domain: 'temple.edu' },
  { name: 'Tennessee Technological University', domain: 'tntech.edu' },
  { name: 'Texas A&M University', domain: 'tamu.edu' },
  { name: 'Texas A&M University–Commerce', domain: 'tamuc.edu' },
  { name: 'Texas Christian University', domain: 'tcu.edu' },
  { name: 'Texas Southern University', domain: 'tsu.edu' },
  { name: 'Texas State University', domain: 'txstate.edu' },
  { name: 'Texas Tech University', domain: 'ttu.edu' },
  { name: 'The Citadel, The Military College of South Carolina', domain: 'citadel.edu' },
  { name: 'The College of New Jersey', domain: 'tcnj.edu' },
  { name: 'The New School', domain: 'newschool.edu' },
  { name: 'The University of Alabama', domain: 'ua.edu' },
  { name: 'The University of British Columbia', domain: 'ubc.ca' },
  { name: 'The University of Texas at Arlington', domain: 'uta.edu' },
  { name: 'The University of Texas at Austin', domain: 'utexas.edu' },
  { name: 'The University of Texas at Dallas', domain: 'utdallas.edu' },
  { name: 'The University of Texas at El Paso', domain: 'utep.edu' },
  { name: 'The University of Texas at San Antonio', domain: 'utsa.edu' },
  { name: 'Towson University', domain: 'towson.edu' },
  { name: 'Transylvania University', domain: 'transy.edu' },
  { name: 'Trine University', domain: 'trine.edu' },
  { name: 'Trinity College', domain: 'trincoll.edu' },
  { name: 'Trinity Washington University', domain: 'trinitydc.edu' },
  { name: 'Truman State University', domain: 'truman.edu' },
  { name: 'Tufts University', domain: 'tufts.edu' },
  { name: 'Tulane University', domain: 'tulane.edu' },
  { name: 'United States Air Force Academy', domain: 'usafa.edu' },
  { name: 'United States Coast Guard Academy', domain: 'uscga.edu' },
  { name: 'United States Military Academy', domain: 'westpoint.edu' },
  { name: 'United States Naval Academy', domain: 'usna.edu' },
  { name: 'University at Albany, SUNY', domain: 'albany.edu' },
  { name: 'University at Buffalo, SUNY', domain: 'buffalo.edu' },
  { name: 'University College London', domain: 'ucl.ac.uk' },
  { name: 'University of Aberdeen', domain: 'abdn.ac.uk' },
  { name: 'University of Adelaide', domain: 'adelaide.edu.au' },
  { name: 'University of Akron', domain: 'uakron.edu' },
  { name: 'University of Alabama at Birmingham', domain: 'uab.edu' },
  { name: 'University of Alaska Anchorage', domain: 'uaa.alaska.edu' },
  { name: 'University of Alaska Fairbanks', domain: 'uaf.edu' },
  { name: 'University of Alberta', domain: 'ualberta.ca' },
  { name: 'University of Arizona', domain: 'arizona.edu' },
  { name: 'University of Arkansas', domain: 'uark.edu' },
  { name: 'University of Auckland', domain: 'auckland.ac.nz' },
  { name: 'University of Bath', domain: 'bath.ac.uk' },
  { name: 'University of Birmingham', domain: 'birmingham.ac.uk' },
  { name: 'University of Bradford', domain: 'bradford.ac.uk' },
  { name: 'University of Bristol', domain: 'bristol.ac.uk' },
  { name: 'University of Calgary', domain: 'ucalgary.ca' },
  { name: 'University of California, Berkeley', domain: 'berkeley.edu' },
  { name: 'University of California, Davis', domain: 'ucdavis.edu' },
  { name: 'University of California, Irvine', domain: 'uci.edu' },
  { name: 'University of California, Los Angeles', domain: 'ucla.edu' },
  { name: 'University of California, Merced', domain: 'ucmerced.edu' },
  { name: 'University of California, Riverside', domain: 'ucr.edu' },
  { name: 'University of California, San Diego', domain: 'ucsd.edu' },
  { name: 'University of California, Santa Barbara', domain: 'ucsb.edu' },
  { name: 'University of California, Santa Cruz', domain: 'ucsc.edu' },
  { name: 'University of Cambridge', domain: 'cam.ac.uk' },
  { name: 'University of Canberra', domain: 'canberra.edu.au' },
  { name: 'University of Canterbury', domain: 'canterbury.ac.nz' },
  { name: 'University of Central Florida', domain: 'ucf.edu' },
  { name: 'University of Central Missouri', domain: 'ucmo.edu' },
  { name: 'University of Chicago', domain: 'uchicago.edu' },
  { name: 'University of Cincinnati', domain: 'uc.edu' },
  { name: 'University of Colorado Boulder', domain: 'colorado.edu' },
  { name: 'University of Colorado Denver', domain: 'ucdenver.edu' },
  { name: 'University of Connecticut', domain: 'uconn.edu' },
  { name: 'University of Dayton', domain: 'udayton.edu' },
  { name: 'University of Delaware', domain: 'udel.edu' },
  { name: 'University of Denver', domain: 'du.edu' },
  { name: 'University of Dundee', domain: 'dundee.ac.uk' },
  { name: 'University of East Anglia', domain: 'uea.ac.uk' },
  { name: 'University of Edinburgh', domain: 'ed.ac.uk' },
  { name: 'University of Exeter', domain: 'exeter.ac.uk' },
  { name: 'University of Florida', domain: 'ufl.edu' },
  { name: 'University of Georgia', domain: 'uga.edu' },
  { name: 'University of Glasgow', domain: 'gla.ac.uk' },
  { name: 'University of Guelph', domain: 'uoguelph.ca' },
  { name: 'University of Hawaiʻi at Mānoa', domain: 'hawaii.edu' },
  { name: 'University of Houston', domain: 'uh.edu' },
  { name: 'University of Idaho', domain: 'uidaho.edu' },
  { name: 'University of Illinois Chicago', domain: 'uic.edu' },
  { name: 'University of Illinois Urbana-Champaign', domain: 'illinois.edu' },
  { name: 'University of Iowa', domain: 'uiowa.edu' },
  { name: 'University of Kansas', domain: 'ku.edu' },
  { name: 'University of Kentucky', domain: 'uky.edu' },
  { name: 'University of Leeds', domain: 'leeds.ac.uk' },
  { name: 'University of Liverpool', domain: 'liverpool.ac.uk' },
  { name: 'University of Louisiana at Lafayette', domain: 'louisiana.edu' },
  { name: 'University of Louisville', domain: 'louisville.edu' },
  { name: 'University of Maine', domain: 'maine.edu' },
  { name: 'University of Manchester', domain: 'manchester.ac.uk' },
  { name: 'University of Manitoba', domain: 'umanitoba.ca' },
  { name: 'University of Maryland, Baltimore County', domain: 'umbc.edu' },
  { name: 'University of Maryland, College Park', domain: 'umd.edu' },
  { name: 'University of Massachusetts Amherst', domain: 'umass.edu' },
  { name: 'University of Massachusetts Lowell', domain: 'uml.edu' },
  { name: 'University of Memphis', domain: 'memphis.edu' },
  { name: 'University of Miami', domain: 'miami.edu' },
  { name: 'University of Michigan', domain: 'umich.edu' },
  { name: 'University of Minnesota Twin Cities', domain: 'umn.edu' },
  { name: 'University of Mississippi', domain: 'olemiss.edu' },
  { name: 'University of Missouri', domain: 'missouri.edu' },
  { name: 'University of Montana', domain: 'umt.edu' },
  { name: 'University of Nebraska–Lincoln', domain: 'unl.edu' },
  { name: 'University of Nebraska Omaha', domain: 'unomaha.edu' },
  { name: 'University of Nevada, Las Vegas', domain: 'unlv.edu' },
  { name: 'University of Nevada, Reno', domain: 'unr.edu' },
  { name: 'University of New Hampshire', domain: 'unh.edu' },
  { name: 'University of New Mexico', domain: 'unm.edu' },
  { name: 'University of New Orleans', domain: 'uno.edu' },
  { name: 'University of Newcastle, Australia', domain: 'newcastle.edu.au' },
  { name: 'University of North Carolina at Chapel Hill', domain: 'unc.edu' },
  { name: 'University of North Carolina at Charlotte', domain: 'charlotte.edu' },
  { name: 'University of North Carolina at Greensboro', domain: 'uncg.edu' },
  { name: 'University of North Carolina Wilmington', domain: 'uncw.edu' },
  { name: 'University of North Dakota', domain: 'und.edu' },
  { name: 'University of North Florida', domain: 'unf.edu' },
  { name: 'University of North Texas', domain: 'unt.edu' },
  { name: 'University of Northern Colorado', domain: 'unco.edu' },
  { name: 'University of Northern Iowa', domain: 'uni.edu' },
  { name: 'University of Notre Dame', domain: 'nd.edu' },
  { name: 'University of Oklahoma', domain: 'ou.edu' },
  { name: 'University of Oregon', domain: 'uoregon.edu' },
  { name: 'University of Otago', domain: 'otago.ac.nz' },
  { name: 'University of Oxford', domain: 'ox.ac.uk' },
  { name: 'University of Pennsylvania', domain: 'upenn.edu' },
  { name: 'University of Pittsburgh', domain: 'pitt.edu' },
  { name: 'University of Portland', domain: 'up.edu' },
  { name: 'University of Queensland', domain: 'uq.edu.au' },
  { name: 'University of Reading', domain: 'reading.ac.uk' },
  { name: 'University of Rhode Island', domain: 'uri.edu' },
  { name: 'University of Richmond', domain: 'richmond.edu' },
  { name: 'University of Rochester', domain: 'rochester.edu' },
  { name: 'University of San Diego', domain: 'sandiego.edu' },
  { name: 'University of San Francisco', domain: 'usfca.edu' },
  { name: 'University of Saskatchewan', domain: 'usask.ca' },
  { name: 'University of Sheffield', domain: 'sheffield.ac.uk' },
  { name: 'University of South Alabama', domain: 'southalabama.edu' },
  { name: 'University of South Carolina', domain: 'sc.edu' },
  { name: 'University of South Dakota', domain: 'usd.edu' },
  { name: 'University of South Florida', domain: 'usf.edu' },
  { name: 'University of Southern California', domain: 'usc.edu' },
  { name: 'University of Southern Maine', domain: 'maine.edu' },
  { name: 'University of St Andrews', domain: 'st-andrews.ac.uk' },
  { name: 'University of Strathclyde', domain: 'strath.ac.uk' },
  { name: 'University of Sussex', domain: 'sussex.ac.uk' },
  { name: 'University of Sydney', domain: 'sydney.edu.au' },
  { name: 'University of Tasmania', domain: 'utas.edu.au' },
  { name: 'University of Technology Sydney', domain: 'uts.edu.au' },
  { name: 'University of Tennessee, Knoxville', domain: 'utk.edu' },
  { name: 'University of Texas Rio Grande Valley', domain: 'utrgv.edu' },
  { name: 'University of the Cumberlands', domain: 'ucumberlands.edu' },
  { name: 'University of the Pacific', domain: 'pacific.edu' },
  { name: 'University of Toledo', domain: 'utoledo.edu' },
  { name: 'University of Toronto', domain: 'utoronto.ca' },
  { name: 'University of Tulsa', domain: 'utulsa.edu' },
  { name: 'University of Utah', domain: 'utah.edu' },
  { name: 'University of Vermont', domain: 'uvm.edu' },
  { name: 'University of Victoria', domain: 'uvic.ca' },
  { name: 'University of Virginia', domain: 'virginia.edu' },
  { name: 'University of Waikato', domain: 'waikato.ac.nz' },
  { name: 'Goldsmiths, University of London', domain: 'gold.ac.uk' },
  { name: 'University of South Australia', domain: 'unisa.edu.au' },
  { name: 'University of Warwick', domain: 'warwick.ac.uk' },
  { name: 'University of Washington', domain: 'washington.edu' },
  { name: 'University of Waterloo', domain: 'uwaterloo.ca' },
  { name: 'University of West Florida', domain: 'uwf.edu' },
  { name: 'University of Western Australia', domain: 'uwa.edu.au' },
  { name: 'University of Western Sydney', domain: 'westernsydney.edu.au' },
  { name: 'University of Wisconsin–Eau Claire', domain: 'uwec.edu' },
  { name: 'University of Wisconsin–Madison', domain: 'wisc.edu' },
  { name: 'University of Wisconsin–Milwaukee', domain: 'uwm.edu' },
  { name: 'University of Wisconsin–Whitewater', domain: 'uww.edu' },
  { name: 'University of Wyoming', domain: 'uwyo.edu' },
  { name: 'University of York', domain: 'york.ac.uk' },
  { name: 'Utah State University', domain: 'usu.edu' },
  { name: 'Utah Valley University', domain: 'uvu.edu' },
  { name: 'Vanderbilt University', domain: 'vanderbilt.edu' },
  { name: 'Vassar College', domain: 'vassar.edu' },
  { name: 'Villanova University', domain: 'villanova.edu' },
  { name: 'Virginia Commonwealth University', domain: 'vcu.edu' },
  { name: 'Virginia Military Institute', domain: 'vmi.edu' },
  { name: 'Virginia Tech', domain: 'vt.edu' },
  { name: 'Victoria University of Wellington', domain: 'victoria.ac.nz' },
  { name: 'Wake Forest University', domain: 'wfu.edu' },
  { name: 'Wabash College', domain: 'wabash.edu' },
  { name: 'Washington and Lee University', domain: 'wlu.edu' },
  { name: 'Washington State University', domain: 'wsu.edu' },
  { name: 'Washington University in St. Louis', domain: 'wustl.edu' },
  { name: 'Wayne State University', domain: 'wayne.edu' },
  { name: 'Weber State University', domain: 'weber.edu' },
  { name: 'Wellesley College', domain: 'wellesley.edu' },
  { name: 'Wesleyan University', domain: 'wesleyan.edu' },
  { name: 'West Chester University of Pennsylvania', domain: 'wcupa.edu' },
  { name: 'West Virginia University', domain: 'wvu.edu' },
  { name: 'Western Carolina University', domain: 'wcu.edu' },
  { name: 'Western Kentucky University', domain: 'wku.edu' },
  { name: 'Western Michigan University', domain: 'wmich.edu' },
  { name: 'Western University', domain: 'uwo.ca' },
  { name: 'Western Washington University', domain: 'wwu.edu' },
  { name: 'Westminster College (Utah)', domain: 'westminster.edu' },
  { name: 'Wheaton College (Illinois)', domain: 'wheaton.edu' },
  { name: 'Wheaton College (Massachusetts)', domain: 'wheatoncollege.edu' },
  { name: 'Whitman College', domain: 'whitman.edu' },
  { name: 'William & Mary', domain: 'wm.edu' },
  { name: 'William Carey University', domain: 'wmcarey.edu' },
  { name: 'Williams College', domain: 'williams.edu' },
  { name: 'Winona State University', domain: 'winona.edu' },
  { name: 'Wright State University', domain: 'wright.edu' },
  { name: 'Xavier University', domain: 'xavier.edu' },
  { name: 'Xavier University of Louisiana', domain: 'xula.edu' },
  { name: 'Yale University', domain: 'yale.edu' },
  { name: 'Yeshiva University', domain: 'yu.edu' },
  { name: 'York University', domain: 'yorku.ca' },
  { name: 'Youngstown State University', domain: 'ysu.edu' },

  /* Search-only (not on default ranked list): top international & regional hubs */
  { name: 'ETH Zurich', domain: 'ethz.ch' },
  { name: 'EPFL', domain: 'epfl.ch' },
  { name: 'Technical University of Munich', domain: 'tum.de' },
  { name: 'University of Amsterdam', domain: 'uva.nl' },
  { name: 'Delft University of Technology', domain: 'tudelft.nl' },
  { name: 'Politecnico di Milano', domain: 'polimi.it' },
  { name: 'The University of Hong Kong', domain: 'hku.hk' },
  { name: 'The Chinese University of Hong Kong', domain: 'cuhk.edu.hk' },
  { name: 'Nanyang Technological University', domain: 'ntu.edu.sg' },
  { name: 'Seoul National University', domain: 'snu.ac.kr' },
  { name: 'KAIST', domain: 'kaist.ac.kr' },
  { name: 'Yonsei University', domain: 'yonsei.ac.kr' },
  { name: 'Korea University', domain: 'korea.ac.kr' },
  { name: 'POSTECH', domain: 'postech.ac.kr' },
  { name: 'Tsinghua University', domain: 'tsinghua.edu.cn' },
  { name: 'Peking University', domain: 'pku.edu.cn' },
  { name: 'Fudan University', domain: 'fudan.edu.cn' },
  { name: 'Shanghai Jiao Tong University', domain: 'sjtu.edu.cn' },
  { name: 'Zhejiang University', domain: 'zju.edu.cn' },
  { name: 'University of Science and Technology of China', domain: 'ustc.edu.cn' },
  { name: 'Nanjing University', domain: 'nju.edu.cn' },
  { name: 'The University of Tokyo', domain: 'u-tokyo.ac.jp' },
  { name: 'Kyoto University', domain: 'kyoto-u.ac.jp' },
  { name: 'Tokyo Institute of Technology', domain: 'titech.ac.jp' },
  { name: 'Indian Institute of Technology Bombay', domain: 'iitb.ac.in' },
  { name: 'Indian Institute of Technology Delhi', domain: 'iitd.ac.in' },
  { name: 'Indian Institute of Technology Madras', domain: 'iitm.ac.in' },
  { name: 'Indian Institute of Technology Kanpur', domain: 'iitk.ac.in' },
  { name: 'Indian Institute of Technology Kharagpur', domain: 'iitkgp.ac.in' },
  { name: 'Indian Institute of Technology Roorkee', domain: 'iitr.ac.in' },
  { name: 'Indian Institute of Science', domain: 'iisc.ac.in' },
  { name: 'National Taiwan University', domain: 'ntu.edu.tw' }
];
